import React from 'react';

import Lozenge from '@atlaskit/lozenge';
import Spinner from '@atlaskit/spinner';

import { ExecutionStatus } from '@qality/common-model';
import { CssUtils } from '@qality/common-utils';

import { SpinnerWrapperStyled } from './ExecutionStatusLozenge.styled';

type Props = {
  status: ExecutionStatus;
  isLoading?: boolean;
};

export const ExecutionStatusLozenge = ({
  status,
  isLoading = false,
}: Props): JSX.Element => {
  if (isLoading) {
    return (
      <Lozenge>
        <SpinnerWrapperStyled>
          <Spinner size='xsmall' testId='loading-spinner' />
        </SpinnerWrapperStyled>
      </Lozenge>
    );
  }

  if (!status) {
    return null;
  }

  return (
    <Lozenge
      style={{
        color: CssUtils.cssDsTokenVar(status.color.textToken),
        backgroundColor: CssUtils.cssDsTokenVar(status.color.backgroundToken),
      }}
    >
      {status.name}
    </Lozenge>
  );
};
